import React from 'react';
import { APP_STORE_URL, PLAY_STORE_URL } from './AppDownloadCta';
import { AppleLogo, GooglePlayLogo } from '../AppDownloadPopup';

/** Kleiner, dezenter App-Download-Hinweis für die Sidebar. */
const SidebarAppCta: React.FC = () => (
  <section className="rounded-2xl border border-zinc-800 bg-zinc-900 p-4">
    <div className="flex items-center gap-3">
      <img
        src="/icon.png"
        alt=""
        className="h-10 w-10 shrink-0 rounded-xl shadow-[0_2px_12px_rgba(63,206,209,0.25)]"
      />
      <div className="min-w-0">
        <h2 className="text-sm font-bold text-white">DartCloud App</h2>
        <p className="truncate text-xs text-gray-500">Live-Scores & Turniere mobil</p>
      </div>
    </div>
    <div className="mt-3 grid grid-cols-2 gap-2">
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center gap-1.5 rounded-lg border border-zinc-700 py-1.5 text-center text-xs font-semibold text-gray-300 transition-colors hover:border-[#3fced1]/60 hover:text-white"
      >
        <AppleLogo size={13} />
        App Store
      </a>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center gap-1.5 rounded-lg border border-zinc-700 py-1.5 text-center text-xs font-semibold text-gray-300 transition-colors hover:border-[#3fced1]/60 hover:text-white"
      >
        <GooglePlayLogo size={13} />
        Google Play
      </a>
    </div>
  </section>
);

export default SidebarAppCta;
